import{__decorate as i,e as a,n as t}from"../d4cffba7.js";import{x as o,y as e,n,r as s}from"../493beda6.js";import{exportParts as c}from"../directives/ExportParts.js";import{defaultStyles as r}from"../styles.js";import{classPartMap as d}from"../utils.js";import{Tooltip as l}from"./Tooltip.js";import"../icons/monochrome/broken-image.js";import"../icons/color/info.js";import"../icons/color/alert.js";import"../icons/color/missing.js";import"../f75f919c.js";import"../af1106fb.js";import"./Popover.js";import"../icons/monochrome/help.js";var b;let h=b=class extends n{constructor(){super(...arguments),this.src="",this.badge="none",this.selected=!1,this.badgeHelpText=""}static get styles(){return[r,s`
        :host {
          display: inline-block;
          width: var(--cai-thumbnail-size, 72px);
          height: var(--cai-thumbnail-size, 72px);
        }
        .container {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          border-radius: var(--cai-thumbnail-border-radius, 3px);
          transition: box-shadow 200ms ease-in-out;
          box-shadow: 0 0 0 0 transparent;
        }
        .selected {
          box-shadow: var(--cai-thumbnail-selected-shadow-offset-x, 0)
            var(--cai-thumbnail-selected-shadow-offset-y, 0)
            var(--cai-thumbnail-selected-shadow-blur, 0)
            var(--cai-thumbnail-selected-shadow-spread, 3px)
            var(--cai-thumbnail-selected-shadow-color, #1473e6);
        }
        cai-tooltip.badge-tooltip,
        .badge-no-tooltip {
          position: absolute;
          top: var(--cai-thumbnail-badge-icon-top, 1px);
          right: var(--cai-thumbnail-badge-icon-right, 1px);
          left: var(--cai-thumbnail-badge-icon-left, auto);
          bottom: var(--cai-thumbnail-badge-icon-bottom, auto);
          width: var(--cai-thumbnail-badge-icon-width, 20px);
          height: var(--cai-thumbnail-badge-icon-height, 20px);
        }
        cai-tooltip.badge-tooltip {
          pointer-events: auto;
        }
        .badge-icon {
          --cai-icon-width: var(--cai-thumbnail-badge-icon-width, 20px);
          --cai-icon-height: var(--cai-thumbnail-badge-icon-height, 20px);
        }
        .no-image {
          --cai-icon-width: var(
            --cai-thumbnail-no-image-icon-width,
            var(--cai-icon-width, 20px)
          );
          --cai-icon-width: var(
            --cai-thumbnail-no-image-icon-height,
            var(--cai-icon-height, 20px)
          );
          --cai-icon-fill: var(
            --cai-thumbnail-no-image-icon-fill,
            var(--cai-icon-width, #8e8e8e)
          );
        }
      `]}render(){const i=d({container:!0,selected:this.selected});return e`<style>
        .container {
          background: url(${this.src}) var(--cai-thumbnail-bgcolor, #eaeaea);
        }
      </style>
      <div class=${i} part=${b.cssParts.container}>
        <slot name="badge">
          ${"none"!==this.badge&&this.badgeHelpText?e`<cai-tooltip
                class="badge-tooltip"
                exportParts=${c(l.cssParts)}
              >
                <div slot="content">${this.badgeHelpText}</div>
                <div
                  class="included-badge"
                  ${b.cssParts.badge}
                  slot="trigger"
                >
                  ${b.badgeMap[this.badge]}
                </div>
              </cai-tooltip>`:e`<div class="badge-no-tooltip" ${b.cssParts.badge}>
                ${b.badgeMap[this.badge]}
              </div>`}
        </slot>
        ${this.src?o:e`<div class="no-image" ${b.cssParts.noImage}>
              <cai-icon-broken-image></cai-icon-broken-image>
            </div>`}
      </div>`}};h.cssParts={container:"thumbnail-container",badge:"thumbnail-badge",noImage:"thumbnail-badge-no-image"},h.badgeMap={none:o,info:e`<cai-icon-info class="badge-icon"></cai-icon-info>`,missing:e`<cai-icon-missing class="badge-icon"></cai-icon-missing>`,alert:e`<cai-icon-alert class="badge-icon"></cai-icon-alert>`},i([a({type:String})],h.prototype,"src",void 0),i([a({type:String})],h.prototype,"badge",void 0),i([a({type:Boolean})],h.prototype,"selected",void 0),i([a({type:String})],h.prototype,"badgeHelpText",void 0),h=b=i([t("cai-thumbnail")],h);export{h as Thumbnail};
